export const englishCrmMessages = {
  resources: {
    companies: {
      name: "Company |||| Companies",
      forcedCaseName: "Company",
      fields: {
        name: "Company name",
        website: "Website",
        linkedin_url: "LinkedIn URL",
        phone_number: "Phone number",
        created_at: "Created at",
        nb_contacts: "Number of contacts",
        revenue: "Revenue",
        sector: "Sector",
        size: "Size",
        tax_identifier: "Tax Identifier",
        address: "Address",
        city: "City",
        zipcode: "Zip code",
        state_abbr: "State",
        country: "Country",
        description: "Description",
        context_links: "Context links",
        sales_id: "Account manager",
      },
      empty: {
        description: "It seems your company list is empty.",
        title: "No companies found",
      },
      import: {
        title: "Import companies",
      },
      field_categories: {
        contact: "Contact",
        additional_info: "Additional information",
        address: "Address",
        context: "Context",
      },
      action: {
        create: "Create Company",
        edit: "Edit company",
        new: "New Company",
        show: "Show company",
      },
      added_on: "Added on %{date}",
      followed_by: "Followed by %{name}",
      followed_by_you: "Followed by you",
      no_contacts: "No contact",
      nb_contacts: "%{smart_count} contact |||| %{smart_count} contacts",
      nb_deals: "%{smart_count} deal |||| %{smart_count} deals",
      sizes: {
        one_employee: "1 employee",
        two_to_nine_employees: "2-9 employees",
        ten_to_forty_nine_employees: "10-49 employees",
        fifty_to_two_hundred_forty_nine_employees: "50-249 employees",
        two_hundred_fifty_or_more_employees: "250 or more employees",
      },
      autocomplete: {
        create_error: "An error occurred while creating the company",
        create_item: "Create %{item}",
        create_label: "Start typing to create a new company",
      },
    },
    contacts: {
      name: "Contact |||| Contacts",
      forcedCaseName: "Contact",
      field_categories: {
        background_info: "Background info",
        identity: "Identity",
        misc: "Misc",
        personal_info: "Personal info",
        position: "Position",
      },
      fields: {
        first_name: "First name",
        last_name: "Last name",
        last_seen: "Last seen",
        title: "Title",
        company_id: "Company",
        email_jsonb: "Email addresses",
        email: "Email",
        phone_jsonb: "Phone numbers",
        phone_number: "Phone number",
        linkedin_url: "LinkedIn URL",
        background: "Background info (bio, how you met, etc)",
        has_newsletter: "Has newsletter",
        sales_id: "Account manager",
      },
      action: {
        add: "Add contact",
        add_first: "Add your first contact",
        create: "Create contact",
        edit: "Edit contact",
        export_vcard: "Export to vCard",
        new: "New Contact",
        show: "Show contact",
      },
      autocomplete: {
        create_item: "Create %{item}",
        create_label: "Start typing to create a new contact",
      },
      background: {
        last_activity_on: "Last activity on %{date}",
        added_on: "Added on %{date}",
        followed_by: "Followed by %{name}",
        followed_by_you: "Followed by you",
        status_none: "None",
      },
      position_at: "%{title} at",
      position_at_company: "%{title} at %{company}",
      empty: {
        description: "It seems your contact list is empty.",
        title: "No contacts found",
      },
      import: {
        title: "Import contacts",
      },
      inputs: {
        genders: {
          male: "He/Him",
          female: "She/Her",
          nonbinary: "They/Them",
        },
        personal_info_types: {
          work: "Work",
          home: "Home",
          other: "Other",
        },
      },
      list: {
        error_loading: "Error loading contacts",
      },
      show: {
        error_loading: "Error loading contact",
      },
      bulk_tag: {
        action: "Tag",
        back: "Back to tags",
        create_description:
          "Create a new tag and apply it to the selected contacts.",
        description:
          "Choose an existing tag or create a new one for the selected contacts.",
        empty: "No tags yet. Create one to tag the selected contacts.",
        error: "Failed to add tag to contacts",
        removed:
          "Tag removed from %{smart_count} contact |||| Tag removed from %{smart_count} contacts",
        success:
          "Tag added to %{smart_count} contact |||| Tag added to %{smart_count} contacts",
        title: "Add tag to contacts",
      },
      merge: {
        action: "Merge with another contact",
        confirm: "Merge Contacts",
        current_contact: "Current Contact (will be deleted)",
        description: "Merge this contact with another one.",
        error: "Failed to merge contacts",
        merging: "Merging...",
        no_additional_data: "No additional data to merge",
        select_target: "Please select a contact to merge with",
        success: "Contacts merged successfully",
        target_contact: "Target Contact (will be kept)",
        title: "Merge Contact",
        warning_description:
          "All data will be transferred to the second contact. This action cannot be undone.",
        warning_title: "Warning: Destructive Operation",
        what_will_be_merged: "What will be merged:",
      },
      filters: {
        before_last_month: "Before last month",
        before_this_month: "Before this month",
        before_this_week: "Before this week",
        managed_by_me: "Managed by me",
        search: "Search name, company...",
        this_week: "This week",
        today: "Today",
        tags: "Tags",
        tasks: "Tasks",
      },
      hot: {
        empty_change_status:
          'Change the status of a contact by adding a note to that contact and clicking on "show options".',
        empty_hint: 'Contacts with a "hot" status will appear here.',
        title: "Hot Contacts",
      },
    },
    leads: {
      name: "Lead |||| Leads",
      forcedCaseName: "Lead",
      fields: {
        name: "Name",
        phone: "Phone",
        email: "Email",
        company_name: "Company",
        comment: "Comment",
        source: "Source",
        stage_id: "Stage",
        project_id: "Project",
        sales_id: "Responsible",
        contact_id: "Contact",
        created_at: "Received",
      },
      action: {
        new: "New lead",
        create: "New lead",
        back: "Back to lead",
      },
      updated: "Lead updated",
    },
    deals: {
      name: "Deal |||| Deals",
      forcedCaseName: "Deal",
      fields: {
        name: "Name",
        description: "Description",
        company_id: "Company",
        contact_ids: "Contacts",
        categories: "Categories",
        amount: "Budget",
        expected_closing_date: "Expected closing date",
        stage: "Stage",
        sales_id: "Account manager",
        project_id: "Project",
        pipeline_id: "Pipeline",
        stage_id: "Stage",
      },
      action: {
        back_to_deal: "Back to deal",
        create: "Create deal",
        new: "New Deal",
      },
      field_categories: {
        misc: "Misc",
      },
      filters: {
        only_mine: "Only deals I manage",
      },
      archived: {
        action: "Archive",
        error: "Error: deal not archived",
        list_title: "Archived Deals",
        success: "Deal archived",
        title: "Archived Deal",
        view: "View archived deals",
      },
      inputs: {
        linked_to: "Linked to",
      },
      unarchived: {
        action: "Send back to the board",
        error: "Error: deal not unarchived",
        success: "Deal unarchived",
      },
      updated: "Deal updated",
      empty: {
        before_create: "before creating a deal.",
        description: "It seems your deal list is empty.",
        title: "No deals found",
      },
      import: {
        title: "Import deals",
      },
      invalid_date: "Invalid date",
    },
    notes: {
      name: "Note |||| Notes",
      forcedCaseName: "Note",
      fields: {
        status: "Status",
        date: "Date",
        attachments: "Attachments",
        contact_id: "Contact",
        deal_id: "Deal",
      },
      action: {
        add: "Add note",
        add_first: "Add your first note",
        delete: "Delete note",
        edit: "Edit note",
        update: "Update note",
        add_this: "Add this note",
      },
      sheet: {
        create: "Create note",
        create_for: "Create note for %{name}",
        edit: "Edit note",
        edit_for: "Edit note for %{name}",
      },
      deleted: "Note deleted",
      empty: "No notes yet",
      author_added: "%{name} added a note",
      you_added: "You added a note",
      system_added: "1C",
      bitrix_added: "Bitrix24",
      me: "Me",
      list: {
        error_loading: "Error loading notes",
      },
      note_for_contact: "Note for %{name}",
      stepper: {
        hint: "Go to a contact page and add a note",
      },
      added: "Note added",
      inputs: {
        add_note: "Add a note",
        options_hint: "(attach files, or change details)",
        show_options: "Show options",
      },
      actions: {
        attach_document: "Attach document",
      },
      validation: {
        note_or_attachment_required: "A note or an attachment is required",
      },
    },
    sales: {
      name: "User |||| Users",
      fields: {
        first_name: "First name",
        last_name: "Last name",
        email: "Email",
        secondary_email: "Secondary email",
        secondary_emails: "Secondary emails",
        administrator: "Admin",
        disabled: "Disabled",
        password: "Password",
      },
      create: {
        error: "An error occurred while creating the user.",
        success: "User created.",
        title: "Create a new user",
      },
      edit: {
        error: "An error occurred. Please try again.",
        record_not_found: "Record not found",
        success: "User updated successfully",
        title: "Edit %{name}",
      },
      action: {
        new: "New user",
      },
    },
    tasks: {
      name: "Task |||| Tasks",
      forcedCaseName: "Task",
      fields: {
        text: "Description",
        due_date: "Due date",
        type: "Type",
        contact_id: "Contact",
        due_short: "due",
      },
      action: {
        add: "Add task",
        create: "Create task",
        edit: "Edit task",
      },
      actions: {
        postpone_next_week: "Postpone to next week",
        postpone_tomorrow: "Postpone to tomorrow",
        title: "task actions",
      },
      added: "Task added",
      deleted: "Task deleted successfully",
      dialog: {
        create: "Create task",
        create_for: "Create task for %{name}",
      },
      sheet: {
        edit: "Edit task",
        edit_for: "Edit task for %{name}",
      },
      empty: "No tasks yet",
      empty_list_hint: "Tasks added to your contacts will appear here.",
      filters: {
        later: "Later",
        overdue: "Overdue",
        this_week: "This week",
        today: "Today",
        tomorrow: "Tomorrow",
        with_pending: "With pending tasks",
      },
      regarding_contact: "(Re: %{name})",
      updated: "Task updated",
    },
    tags: {
      name: "Tag |||| Tags",
      action: {
        add: "Add tag",
        create: "Create new tag",
      },
      dialog: {
        color: "Color",
        create_title: "Create a new tag",
        edit_title: "Edit tag",
        name_label: "Tag name",
        name_placeholder: "Enter tag name",
      },
      empty: "No tags yet.",
    },
  },
  crm: {
    action: {
      reset_password: "Reset Password",
    },
    auth: {
      first_name: "First name",
      last_name: "Last name",
      confirm_password: "Confirm password",
      confirmation_required:
        "Please follow the link we just sent you by email to confirm your account.",
      recovery_email_sent:
        "If you're a registered user, you should receive a password recovery email shortly.",
      sign_in_failed: "Failed to log in.",
      sign_in_google_workspace: "Sign in with Google Workplace",
      signup: {
        create_account: "Create account",
        create_first_user:
          "Create the first user account to complete the setup.",
        creating: "Creating...",
        initial_user_created: "Initial user successfully created",
      },
      welcome_title: "Welcome to Atomic CRM",
    },
    clients: {
      tabs_label: "Clients",
      people: "People",
      companies: "Companies",
    },
    projects: {
      confirm_delete_stage: "Delete the stage «%{name}»?",
      confirm_delete_pipeline: "Delete the pipeline «%{name}» with its stages?",
      confirm_delete_hint:
        "A stage that holds records cannot be deleted: move them to another stage first.",
      no_active_title: "No active projects",
      no_active_description:
        "Every project is archived. Create a project or restore one from the archive.",
      open_settings: "Settings → Projects",
      import_choose_project: "Import: choose a project",
      outcome_label: "Outcome",
      pipeline_name: "Pipeline name",
      errors: {
        stage_exists: "This pipeline already has a stage with that name",
        member_exists: "This employee is already in the project",
      },
      switcher: "Project",
      all: "All projects",
      pipelines_label: "Deal pipelines",
      none_title: "You are not in any project yet",
      none_description:
        "The owner adds employees to projects in Settings → Employees.",
      title: "Projects",
      general: "General",
      tabs_label: "Settings sections",
      new: "New project",
      create: "Create",
      name: "Name",
      color: "Colour",
      archive: "Archive",
      unarchive: "Restore",
      archived: "archived",
      lead_pipeline: "Leads",
      add_pipeline: "Deal pipeline",
      new_pipeline_name: "New pipeline",
      delete_pipeline: "Delete pipeline",
      stages: "Stages",
      add_stage: "Add stage",
      new_stage: "New stage",
      stage_name: "Stage name",
      drag: "Drag to reorder",
      delete_stage: "Delete stage",
      lead_rules:
        "A lead pipeline has one «won» stage (into a deal) and at least one «lost» stage.",
      members: "Members",
      add_member: "Add employee",
      no_members: "Nobody works in this project yet",
      remove_member: "Remove",
      saved: "Saved",
      owner_sees_all: "The owner sees everything",
      can_delete: "Can delete",
      can_export: "Can export",
      staff_title: "Employees",
      new_employee: "New employee",
      edit_employee: "Edit",
      outcome: {
        open: "in progress",
        won: "won",
        lost: "lost",
      },
      access: {
        label: "Access",
        none: "No access",
        own: "Own records",
        department: "Department",
        all: "Everything",
      },
      roles: {
        owner: "Owner",
        head: "Head",
        manager: "Manager",
      },
    },
    leads: {
      sources: {
        call: "Call",
        site: "Website",
        avito: "Avito",
        drom: "Drom",
        email: "Email",
        other: "Other",
      },
      convert: "To deal",
      open_deal: "Open deal",
      converted: "The deal is created",
      convert_error: "Could not create the deal",
      no_responsible: "No responsible",
      only_mine: "Only my leads",
      view_label: "View",
      view_board: "Board",
      view_list: "List",
      list: "Leads",
      empty: "No leads yet",
      choose_project:
        "The board is shown for one project: choose it in the header. Below are the leads of all projects.",
      won_hint: "Leads get here through «To deal»",
      column_count: "%{smart_count} lead |||| %{smart_count} leads",
    },
    connections: {
      title: "Connections",
      is_set: "set ✓",
      not_set: "not set",
      save: "Save",
      remove: "Remove",
      saved: "Saved",
      removed: "Removed",
      replace_placeholder: "Type a new value to replace it",
      generate: "Create new",
      generate_confirm: "The old key will stop working. Create a new one?",
      generate_yes: "Yes, create",
      generated_once: "Copy it now: this key will not be shown again.",
      paste_own: "Or paste the key from the PBX account",
      copy: "Copy",
      copy_failed: "Could not copy. Select the text and copy it by hand",
      public_url: "CRM address",
      public_url_hint:
        "Used for the links in notifications and the addresses below. For example, https://crm.example.com",
      public_url_bad: "The address must start with https:// or http://",
      mail: {
        title: "Company mailbox",
        leads_from_unknown: "Letters from unknown addresses create a lead",
        leads_from_unknown_hint:
          "A letter from an address that is not a contact becomes a lead. While off, the CRM leaves such letters alone.",
        hint: "Letters of employees without their own mailbox are sent from this mailbox. The CRM reads replies here as well.",
        people: "Employees' own mailboxes",
        people_empty: "Nobody has their own mailbox yet",
        remove_person: "Remove the employee's mailbox",
      },
      telegram: {
        title: "Telegram",
        hint: "Employees get new leads, missed calls, deal handovers and stages, and overdue tasks in Telegram.",
        steps:
          "1. Create a bot with @BotFather (/newbot) and paste its token here. 2. Each employee enters their chat_id in the profile and presses «Test».",
        bot_token: "Bot token",
        api_base: "Telegram proxy address",
        api_base_hint:
          "Only if the hosting cannot reach api.telegram.org. Usually empty.",
      },
      leads: {
        title: "Leads from the site and marketplaces",
        hint: "The site form, marketplaces and other services send leads to this address (POST).",
        token: "Lead key",
        url_label: "Lead address",
        header_hint:
          "The key goes in the address (?token=) or in the X-Hook-Token header.",
      },
      telephony: {
        title: "Telephony",
        provider: "PBX",
        provider_none: "None",
        provider_megafon: "MegaFon",
        lines: "Company numbers and projects",
        lines_hint:
          "A call to a listed number goes to its project. Other calls go to the client's project or the main one.",
        number: "Number",
        project: "Project",
        add_line: "Add number",
        remove_line: "Remove number",
        save: "Save telephony",
        saved: "Telephony saved",
        megafon_hint:
          "In the PBX account («CRM integration») enter the address below and the key for requests from the PBX. Take the API address and API key from there too.",
        megafon_url_label: "CRM address for the PBX",
        megafon_crm_token: "Key for requests from the PBX",
        megafon_api_url: "PBX API address",
        megafon_api_key: "PBX API key",
        own_title: "Own PBX",
        own_hint:
          "Our own PBX sends call events to this address with the X-Telephony-Token header.",
        own_token: "Call events key",
        own_url_label: "Events address",
      },
      onec: {
        title: "1C",
        hint: "Orders and payments from 1C appear on the deal. The CRM reads 1C every 30 minutes and never changes it.",
        steps:
          "1. Publish the OData interface in 1C and create a read-only user. 2. Enter the address, login and password, turn the sync on. 3. Managers write the deal number in the order's comment, e.g. CRM-101.",
        enabled: "Sync with 1C",
        odata_url: "OData address",
        odata_url_hint:
          "For example, http://1c.example.com/base/odata/standard.odata",
        bad_url: "The address must start with http:// or https://",
        key: "How 1C marks the deal number",
        prefix: "Before the number",
        number: "deal number",
        suffix: "After the number",
        suffix_placeholder: "may be empty",
        example: "Example:",
        key_hint:
          "The manager writes this in the order's number or comment. A second order of the same deal: CRM-101-2. A number without this prefix does not link. In the example, ␣ means a space.",
        prefix_empty: "Enter what goes before the number, e.g. CRM-",
        key_long: "At most 20 characters before and after the number",
        prefix_bad: "Before the number: letters and no digits, e.g. CRM-",
        suffix_bad: "After the number: no digits",
        password_cleared:
          "The 1C address changed, so the 1C password was erased. Please enter the 1C password again",
        user: "1C login",
        password: "1C password",
        save: "Save 1C",
        saved: "1C settings saved",
        check: "Check connection",
        check_hint: "Checks the saved address, login and password.",
        check_ok: "1C answers. First order: %{number} of %{date}",
        check_ok_empty: "1C answers. No orders yet",
      },
    },
    telegram: {
      chat_id: "Telegram chat_id",
      check: "Test",
      sent: "Message sent, check Telegram",
      saved: "chat_id saved",
      hint: "To get notifications, find the company bot in Telegram and press «Start» (/start). @userinfobot tells you your chat_id: write to it and copy the Id number.",
    },
    bitrix: {
      title: "Bitrix24",
      hint: "Clients, leads, deals, notes and tasks from Bitrix24. The CRM only reads Bitrix and changes nothing there.",
      steps:
        "1. In Bitrix open Developer resources → Other → Inbound webhook, tick the crm, user and task rights and save. 2. Paste the webhook address here. 3. Press «Trial move» and look at the result. 4. Press «Move» or turn the sync on.",
      webhook: "Webhook address",
      webhook_hint:
        "It looks like https://portal-address/rest/1/key/. Once saved, the address is not shown.",
      mode: "Sync with Bitrix24",
      mode_on:
        "On: every 10 minutes the CRM takes the changes from Bitrix. Bitrix records are read-only here and are changed in Bitrix. Your own notes and tasks can be added to them.",
      mode_off:
        "Off: the CRM is kept here. To move the Bitrix data once, press «Move».",
      check: "Check",
      check_ok: "Bitrix24 answers. The webhook belongs to %{name}",
      check_ok_empty: "Bitrix24 answers",
      dry_run: "Trial move",
      run: "Move",
      run_hint:
        "The trial move writes nothing and shows what would be created. Moving again updates the records, without duplicates.",
      no_webhook: "First paste the webhook address and save it",
      run_confirm_title: "Move the data from Bitrix24?",
      run_confirm:
        "It may take a few minutes. The records appear in the CRM, the result is shown below.",
      dry_started: "The trial move has started",
      started: "The move has started",
      running: {
        import: "Moving…",
        dry: "Trial move in progress…",
        sync: "Syncing…",
        starting: "Starting…",
      },
      last_pulled: "Last move: %{time}",
      report_dry: "Trial move %{time}: nothing written to the CRM",
      report_import: "Move result %{time}",
      report_sync: "Sync result %{time}",
      created: "created",
      updated: "updated",
      skipped: "skipped",
      entities: {
        projects: "Projects",
        stages: "Stages",
        companies: "Companies",
        contacts: "Contacts",
        leads: "Leads",
        deals: "Deals",
        notes: "Notes",
        tasks: "Tasks",
      },
      archived: "Deleted in Bitrix, archived here:",
      users_matched: "Bitrix employees found here by e-mail: %{count}",
      users_unmatched:
        "Not found here by e-mail, their records went to the owner:",
      lines: "Please check:",
      lines_all: "Show all (%{count})",
      lines_less: "Show less",
      badge: "from Bitrix",
      badge_hint: "A Bitrix24 record. It is changed in Bitrix",
    },
    onec: {
      title: "1C",
      order: "Order %{number} of %{date}",
      order_no_number: "Order of %{date}",
      amount: "Amount",
      paid: "Paid",
      rest: "Left",
      progress: "Paid %{percent}%",
      synced: "Synced with 1C %{time}",
      total: "All orders:",
      total_line: "paid %{paid} of %{amount}, left %{rest}",
      empty:
        "No order in 1C yet. To link an order, write %{key} in its comment",
      status: {
        unpaid: "Not paid",
        partial: "Partly paid",
        paid: "Paid",
      },
    },
    mail: {
      title: "Emails",
      write: "Write an email",
      empty: "No emails yet",
      only_latest:
        "Showing the latest %{smart_count} email |||| Showing the latest %{smart_count} emails",
      to: "To",
      cc: "Cc",
      to_hint: "Separate several addresses with commas",
      subject: "Subject",
      body: "Message",
      template: "Template",
      no_template: "No template",
      attach: "Attach a file",
      attach_hint: "Up to 20 MB in total",
      remove_file: "Remove the file",
      send: "Send",
      sent: "Email sent",
      sent_except: "Email sent, except: %{list}",
      status_sent_except: "sent, except: %{list}",
      send_error: "Email not sent",
      upload_error: "The file was not uploaded",
      from: "From",
      no_subject: "(no subject)",
      show_images: "Show images",
      images_blocked: "Images from the internet are not loaded",
      as_text: "As text",
      as_html: "As sent",
      attachments: "Attachments",
      files_not_kept:
        "The CRM does not keep files of incoming emails. Open them in your mailbox.",
      status: {
        queued: "sending",
        sent: "sent",
        failed: "not sent",
        received: "received",
      },
      direction: {
        in: "Incoming",
        out: "Outgoing",
      },
      mailbox: {
        title: "Email",
        hint: "Emails from cards are sent from your mailbox, and the CRM reads replies from it every 5 minutes. Without your own mailbox, emails go from the company mailbox.",
        presets: "Fill in for",
        from_addr: "Email address",
        from_hint:
          "The login's own address, or another address of the same domain",
        from_name: "Sender name",
        smtp_host: "SMTP server",
        smtp_port: "SMTP port",
        imap_host: "IMAP server",
        imap_port: "IMAP port",
        login: "Login",
        login_hint:
          "Usually the email address. If empty, the CRM uses the email address.",
        password: "App password",
        password_hint:
          "For Yandex, Mail.ru and Gmail, create an app password in the mailbox security settings. The usual password will not work.",
        is_set: "set",
        save: "Save email",
        saved: "Email settings saved",
        nothing_typed: "Fill in at least one field",
        check: "Check",
        check_label: "Check email",
        remove: "Remove mailbox",
        removed: "Mailbox removed",
        status_ok: "Sending is set up",
        status_none: "No mailbox",
        uses_company: "Emails go from the company mailbox",
      },
    },
    mail_templates: {
      title: "Email templates",
      hint: "You can write {{клиент}}, {{сделка}}, {{сумма}} and {{менеджер}} in the subject and text. The CRM fills them in when an employee picks the template.",
      add: "Add a template",
      new_name: "New template",
      name: "Name",
      subject: "Subject",
      body: "Text",
      save: "Save",
      saved: "Template saved",
      delete: "Delete",
      deleted: "Template deleted",
      empty: "No templates yet",
    },
    calls: {
      title: "Calls",
      empty: "No calls yet",
      call: "Call",
      calling: "Calling… pick up your phone",
      call_error: "Could not place the call",
      listen: "Listen",
      nobody: "Unknown employee",
      only_latest:
        "Showing the latest %{smart_count} call |||| Showing the latest %{smart_count} calls",
      kind: {
        incoming: "Incoming",
        outgoing: "Outgoing",
        missed: "Missed",
      },
      status: {
        in_progress: "in progress",
        success: "talked",
        missed: "no answer",
        busy: "busy",
        cancel: "cancelled",
      },
      ext_label: "Extension",
      ext_hint:
        "Extension or PBX login (for MegaFon, the VATS login). The CRM uses it to know who talked and to call from a card.",
      no_ext_hint:
        "Not set, so there is no Call button. The owner sets it in Settings → Employees.",
      ext_saved: "Extension saved",
    },
    board: {
      stage_total: "Total for %{stage}",
    },
    today: {
      title: "Today",
      counter_overdue: "Overdue",
      counter_today: "Due today",
      counter_stale: "Idle deals",
      my_tasks: "My tasks for today",
      no_tasks: "Nothing due today",
      new_leads: "New leads",
      stale_deals: "Deals without movement for 7 days",
      no_stale_deals: "Every open deal moved this week",
      idle_days: "%{smart_count} day idle |||| %{smart_count} days idle",
      more: "and %{smart_count} more",
    },
    common: {
      more_fields: "More",
      account_manager: "Account manager",
      activity: "Activity",
      added: "added",
      details: "Details",
      last_activity_with_date: "last activity %{date}",
      load_more: "Load more",
      misc: "Misc",
      past: "Past",
      read_more: "Read more",
      retry: "Retry",
      show_less: "Show less",
      copied: "Copied!",
      copy: "Copy",
      loading: "Loading...",
      me: "Me",
      task_count: "%{smart_count} task |||| %{smart_count} tasks",
    },
    changelog: {
      title: "Changelog",
    },
    activity: {
      added_company: "%{name} added company",
      you_added_company: "You added company",
      added_contact: "%{name} added",
      you_added_contact: "You added",
      added_note: "%{name} added a note about",
      you_added_note: "You added a note about",
      added_note_about_deal: "%{name} added a note about deal",
      you_added_note_about_deal: "You added a note about deal",
      added_deal: "%{name} added deal",
      you_added_deal: "You added deal",
      at_company: "at",
      to: "to",
      load_more: "Load more activity",
    },
    dashboard: {
      deals_chart: "Upcoming Deal Revenue",
      deals_pipeline: "Deals Pipeline",
      latest_activity: "Latest Activity",
      latest_activity_error: "Error loading latest activity",
      latest_notes: "My Latest Notes",
      latest_notes_added_ago: "added %{timeAgo}",
      recent_contacts: "Recently Viewed",
      stepper: {
        install: "Install Atomic CRM",
        progress: "%{step}/3 done",
        whats_next: "What's next?",
      },
      upcoming_tasks: "Upcoming Tasks",
    },
    data_import: {
      button: "Import CSV",
      complete:
        "Import complete. Imported %{importCount} records, with %{errorCount} errors",
      csv_file: "CSV File",
      error:
        "Failed to import this file, please make sure you provided a valid CSV file.",
      in_progress: "Import in progress…",
      progress:
        "Imported %{importCount} / %{rowCount} records, with %{errorCount} errors.",
      remaining_time: "Estimated remaining time:",
      resource: "Resource",
      sample_download: "Download CSV sample",
      sample_hint: "Here is a sample CSV file you can use as a template",
      start: "Start import",
      stop: "Stop import",
      stopped:
        "Import stopped. Imported %{importCount} records, with %{errorCount} errors",
      title: "Import data",
    },
    header: {
      import_data: "Import from JSON",
    },
    search: {
      title: "Search",
      placeholder: "Search contacts, companies, deals, tasks and notes...",
      hint: "Type at least %{min} characters to search",
      empty: "No result found",
      error: "Search is unavailable right now. Please try again.",
      untitled_result: "(no title)",
      show_more: "Show more",
      groups: {
        contacts: "Contacts",
        companies: "Companies",
        leads: "Leads",
        deals: "Deals",
        tasks: "Tasks",
        contact_notes: "Contact notes",
        deal_notes: "Deal notes",
      },
    },
    image_editor: {
      change: "Change",
      drop_hint: "Drop a file to upload, or click to select it.",
      editable_content: "Editable content",
      title: "Upload and resize image",
      update_image: "Update Image",
    },
    import: {
      action: {
        download_error_report: "Download the error report",
        import: "Import",
        import_another: "Import another file",
      },
      error: {
        unable: "Unable to import this file.",
      },
      idle: {
        description_1:
          "You can import sales, companies, contacts, companies, notes, and tasks.",
        description_2:
          "Data must be in a JSON file matching the following sample:",
      },
      status: {
        all_success: "All records were imported successfully.",
        complete: "Import complete.",
        failed: "Failed",
        imported: "Imported",
        in_progress:
          "Import in progress, please don't navigate away from this page.",
        some_failed: "Some records were not imported.",
        table_caption: "Import status",
      },
      title: "Import from JSON",
    },
    settings: {
      about: "About",
      companies: {
        sectors: "Sectors",
      },
      dark_mode_logo: "Dark Mode Logo",
      deals: {
        categories: "Categories",
        currency: "Currency",
        pipeline_help:
          "Select which deal stages should count as pipeline deals.",
        pipeline_statuses: "Pipeline Statuses",
        stages: "Stages",
      },
      light_mode_logo: "Light Mode Logo",
      notes: {
        statuses: "Statuses",
      },
      reset_defaults: "Reset to Defaults",
      save_error: "Failed to save configuration",
      saved: "Configuration saved successfully",
      saving: "Saving...",
      tasks: {
        types: "Types",
      },
      preferences: "Preferences",
      title: "Settings",
      app_title: "App Title",
      timezone: "Time zone",
      timezone_hint:
        "The company's day: when a task is overdue and when notifications go out (09:00 to 20:00).",
      sections: {
        branding: "Branding",
      },
      validation: {
        duplicate: "Duplicate %{display_name}: %{items}",
        in_use:
          "Cannot remove %{display_name} that are still used by deals: %{items}",
        validating: "Validating\u2026",
        entities: {
          categories: "categories",
          stages: "stages",
        },
      },
    },
    theme: {
      dark: "Dark",
      label: "Theme",
      light: "Light",
      system: "System",
    },
    language: "Language",
    navigation: {
      label: "CRM navigation",
      leads: "Leads",
      clients: "Clients",
      today: "Today",
    },
    profile: {
      add_secondary_email: "Add an email",
      email_taken: "%{email} is already used by another user",
      no_secondary_emails: "None",
      secondary_email_invalid: "%{email} is not a valid email address",
      secondary_email_is_primary: "%{email} is already your main address",
      secondary_email_taken: "%{email} is already used by another user",
      too_many_secondary_emails:
        "You cannot add more than 10 secondary email addresses",
      secondary_emails_help:
        "Other addresses you send emails from. Leave one empty to remove it.",
      inbound: {
        description:
          "You can start sending emails to your server's inbound email address, e.g. by adding it to the %{field} field. Atomic CRM will process the emails and add notes to the corresponding contacts.",
        title: "Inbound email",
      },
      mcp: {
        title: "MCP Server",
        description:
          "Use this URL to connect your AI assistant to your CRM data via the Model Context Protocol (MCP).",
      },
      password: {
        change: "Change password",
        current: "Current password",
        new: "New password",
        changed: "Your password has been changed",
      },
      password_reset_sent:
        "A reset password email has been sent to your email address",
      record_not_found: "Record not found",
      title: "Profile",
      updated: "Your profile has been updated",
      update_error: "An error occurred. Please try again",
    },
    validation: {
      invalid_url: "Must be a valid URL",
      invalid_linkedin_url: "URL must be from linkedin.com",
    },
  },
} as const;

type MessageSchema<T> = {
  [K in keyof T]: T[K] extends string
    ? string
    : T[K] extends Record<string, unknown>
      ? MessageSchema<T[K]>
      : never;
};

type DeepPartial<T> = {
  [K in keyof T]?: T[K] extends Record<string, unknown>
    ? DeepPartial<T[K]>
    : T[K];
};

export type CrmMessages = MessageSchema<typeof englishCrmMessages>;
export type PartialCrmMessages = DeepPartial<CrmMessages>;
